import { Typography, Button } from '@material-ui/core'
import { Helmet } from 'react-helmet-async';
import { useHistory } from 'react-router-dom';
import React from 'react'

const NotFound = () => {
    const history = useHistory();

    return (
        <>
        <Helmet>
            <title>Page Not Found | RYZE Golf</title>
            <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', minHeight: '400px', gap: '16px' }}>
            <Typography variant='h4' style={{ textAlign: 'center' }}>404 — Page Not Found</Typography>
            <Typography variant='body1' style={{ textAlign: 'center' }}>Uh, put me down for a par... This page doesn't exist.</Typography>
            <Button variant='contained' color='primary' onClick={() => history.push('/courses')}>
                Back to Course Search
            </Button>
        </div>
        </>
    )
}

export default NotFound